import React, { Fragment, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import { getInt } from 'utils/functions';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DOCUMENT_TYPES } from 'constants/rightsCodes';

import AllowedStateContainer from '../edit/AllowedStateContainer';
import Header from '../edit/header/Header';
import HeaderLinks from '../edit/header/HeaderLinks';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const Route = props => {
  const historyContext = useHistoryWithContext();
  const [title, setTitle] = useState({ documentTypeName: '', allowedStateName: '' });
  const [disabledSave, setDisabledSave] = useState(false);
  const [onSave, setOnSave] = useState({ fn: () => {} });

  const { getElemByAreaKey } = props;

  const documentTypeId = useMemo(() => getInt(props.match.params.documentTypeId), [props.match.params.documentTypeId]);
  const allowedStateId = useMemo(() => getInt(props.match.params.allowedStateId), [props.match.params.allowedStateId]);

  const onClickClose = useCallback(() => {
    historyContext.push(`/documentTypes/${documentTypeId}/allowedStates`);
  }, [documentTypeId, historyContext]);

  const onChangedAllowedStateTitle = useCallback(allowedStateTitle => {
    setTitle(prev => ({
      ...prev,
      documentTypeName: allowedStateTitle.documentTypeName,
      allowedStateName: allowedStateTitle.allowedStateName
    }));
  }, []);

  const onRedirect = useCallback(
    allowedStateId => {
      historyContext.push(`/documentTypes/${documentTypeId}/allowedStates/${allowedStateId}`);
    },
    [documentTypeId, historyContext]
  );

  const onSaveFnChanged = useCallback((fn, disabledSave) => {
    setOnSave({ fn });
    setDisabledSave(disabledSave);
  }, []);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} onSave={onSave.fn} disabledSave={disabledSave} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TYPES}>
        <AllowedStateContainer
          documentTypeId={documentTypeId}
          allowedStateId={allowedStateId}
          onChangedAllowedStateTitle={onChangedAllowedStateTitle}
          onSaveFnChanged={onSaveFnChanged}
          onRedirect={onRedirect}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired
};

export default withAreaGetter(withRouter(Route));
